import React, { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import AdminLeftMenu from "./AdminLeftMenu";
import { useTranslation } from "react-i18next";

import RealTimeUser from "./Charts/RealtimeUser";
import ActiveUsers from "./Charts/ActiveUsers";
import Sessions from "./Charts/Sessions";
import Bounce from "./Charts/Bounce";
import Organic from "./Charts/Organic";
import SessionDuration from "./Charts/SessionDuration";
import SessionsByDevice from "./Charts/SessionsByDevice";
import SessionsBySource from "./Charts/SessionsBySource";
import PageViewPerPath from "./Charts/PageViewPerPath";
import SessionsByUserType from "./Charts/SessionsByUserType";
import SessionGeo from "./Charts/SessionGeo";
import { useAnalyticsApi } from "react-use-analytics-api";
import { useAuthorize } from "react-use-analytics-api";
import AdminCheck from "./AdminCheck";

const AdminStat = () => {
  const { t, i18n } = useTranslation();
  const { ready, gapi, authorized, error } = useAnalyticsApi();
  const authorize = useAuthorize(gapi, {
    clientId:
      "568824200639-58enea0l8cr2arus6f1hech205ibqvci.apps.googleusercontent.com",
    container: "authorize-container-id",
  });
  useEffect(() => {
    const reloadCount = sessionStorage.getItem("reloadCount");
    console.log("reloadCount", reloadCount);
    if (reloadCount) {
      if (reloadCount > 0) {
        sessionStorage.setItem("reloadCount", String(reloadCount + 1));
      } else {
        window.location.reload();
      }
    } else {
      sessionStorage.setItem("reloadCount", 1);
    }
  }, []);
  return (
    <Grid container>
      <AdminCheck />
      <AdminLeftMenu />
      <Grid item md={9} sm={12}>
        <Grid container>
          <Grid
            item
            md={12}
            sm={12}
            xs={12}
            sx={{ backgroundColor: "#faf9f6", minHeight: "100%", pb: 10 }}
          >
            <Box sx={{ py: 6, px: 3 }}>
              {/* Content */}
              <Box sx={{ display: "flex" }} justifyContent={"space-between"}>
                <Box sx={{ fontSize: "22px" }}>E-Commerce Statistics </Box>
                {/* <Box className="pink_link" sx={{ cursor: "pointer" }}>
                  View Details Stats
                </Box> */}
              </Box>
              <Box
                sx={{
                  mt: 1,
                  borderRadius: "2px",
                  display: "flex",
                  fontSize: "22px",
                }}
              ></Box>
              <Grid container spacing={2}>
                <Grid item md={12} sm={12} xs={12}>
                  <Box
                    sx={{
                      border: "1px solid lightgray",
                      my: 5,
                      backgroundColor: "white",
                      minHeight: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        borderBottom: "1px solid lightgray",
                        py: 2,
                        px: 4,
                        fontWeight: "bold",
                        fontSize: "19px",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "15px",
                      }}
                    >
                      <Box>{t("Graphs")} </Box>
                      <Box sx={{ fontSize: "13px" }}>
                        <div
                          sx={{
                            fontSize: "12px",
                            textAlign: "left",
                            paddingTop: "10px",
                          }}
                        >
                          {t(
                            "Please refresh this page if you don't see the graphs"
                          )}
                        </div>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        px: 4,
                      }}
                    >
                      <Sessions />
                      <ActiveUsers />
                      {/* <RealTimeUser /> */}
                      <Bounce />
                      <Organic />
                      <PageViewPerPath />
                      <Box sx={{ mt: 2 }}>
                        <SessionDuration />
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              {/* End of Content */}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AdminStat;
// users
